module.exports = __webpack_public_path__ + "images/emoji/grey_exclamation.879a82e7793cf4237739.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/grey_exclamation.png
// module id = fHgv
// module chunks = 13